import type { RouteRecordRaw } from 'vue-router';

export const subscriberRoutes: Array<RouteRecordRaw> = [
  {
    path: '/subscriber',
    name: 'subscriber',
    redirect: '/subscriber/list',
    component: () => import('pages/micros/subscription/subscriber/McSubscriber.vue'),
    meta: {
      title: 'Subscribers',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'subscriberList',
        component: () => import('pages/micros/subscription/subscriber/SubscriberList.vue'),
        meta: {
          title: 'Subscribers List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'subscriberDetail',
        component: () => import('pages/micros/subscription/subscriber/SubscriberDetail.vue'),
        meta: {
          title: 'Subscriber Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'subscriberNew',
        component: () => import('pages/micros/subscription/subscriber/SubscriberNew.vue'),
        meta: {
          title: 'New Subscriber',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'userSubscriberDetail',
        component: () => import('pages/micros/subscription/subscriber/UserSubscriberDetail.vue'),
        meta: {
          title: 'User Subscriber Details',
          requiresAuth: true,
        },
      },
    ],
  },
];
